import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { accountRoutes } from './accounts/account.routes';
import { maanagerRoutes } from './managers/manager.routes';
import { userRoutes } from './users/user.routes';
import { routes } from './app.routes';
import { OWL_DATE_TIME_LOCALE } from '@danielmoncada/angular-datetime-picker';
import { MyInterceptor } from './request-interceptors';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyFieldFile } from './users/reimbursement/file-type.component';
import { DatePickerComponent } from './users/reimbursement/date-picker/date-picker.component';
import { CustomFieldSelectComponent } from './users/reimbursement/custom-field-select/custom-field-select.component';
import { FormControl } from '@angular/forms';
import { NgxGooglePlacesAutocompleteComponent } from './users/reimbursement/ngx-google-places-autocomplete/ngx-google-places-autocomplete.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

export function IntegerValidator(control: FormControl): boolean {
  return /^\d+$/.test(control.value);
}
export function showErrorOption(field) {
  return (field.formControl.touched || (field.field.validation && field.field.validation.show)) && !field.formControl.valid;
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(accountRoutes),
    provideRouter(maanagerRoutes),
    provideRouter(userRoutes),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideToastr(),
    BsModalService,
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'en-IN' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MyInterceptor,
      multi: true
    },
    importProvidersFrom(
      FormlyModule.forRoot({
        types: [
          { name: 'file', component: FormlyFieldFile },
          { name: 'date', component: DatePickerComponent },
          { name: 'custom-select', component: CustomFieldSelectComponent },
          {
            name: 'Integer',
            extends: 'input',
            defaultOptions: {
              validators: {
                integer: IntegerValidator
              }
            },
          },
          { name: 'ngx-google-places-autocomplete', component: NgxGooglePlacesAutocompleteComponent },
        ],
        validationMessages: [
          { name: 'required', message: 'This field is required' },
          { name: 'integer', message: 'Invalid Number' }
        ],
        extras: {
          showError: showErrorOption
        },
      }),
      CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory,
      })
    )
  ]
};
